(function(){
    'use strict'

    angular.module('app.tiposPlanilla')
    .factory('TiposPlanillaService', TiposPlanillaService);

    TiposPlanillaService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function TiposPlanillaService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getAllForCalendarizacion: getAllForCalendarizacion,
            getById: getById,
            save: save,
            update: update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/tipos-planilla/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllForCalendarizacion(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/tipos-planilla/calendarizacion/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, tipoPlanillaId){

            var url = apiSettings.apiBaseUrl + 'api/tipos-planilla/' + companiaId + '/' + tipoPlanillaId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(tipoPlanilla){

            if(!tipoPlanilla.companiaId){
                tipoPlanilla.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/tipos-planilla',  
                method: 'POST',  
                data: tipoPlanilla
            });  
            return response;
        };

        function update(tipoPlanilla){

            if(!tipoPlanilla.companiaId){
                tipoPlanilla.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/tipos-planilla',  
                method: 'PUT',  
                data: tipoPlanilla
            });  
            return response;
        };

        function remove(tipoPlanilla){

            if(!tipoPlanilla.companiaId){
                tipoPlanilla.companiaId = UserInfoService.getCompaniaId();
            }
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/tipos-planilla',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: tipoPlanilla
            });  
            return response;
        };

    };

})();